module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_50_75.81cf1054.png";